import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import {
  FREE_DELIVERY_VISIBLE,
  THRESHOLD,
  ABOVE_THRESHOLD_MSG,
  getBelowThresholdMsg,
} from 'app/utils/freeDeliveryUtils';
import Image from '../../utils/image';

function ConfirmationView(props) {
  const { product, closeProductInfo, addedMsgId, viewAddedProductsMsgId, addedProductsUrl, cartData = null } = props;
  // const mainImage = product.imageSet.items[0].src;
  const product404ImageSrc = 'https://i8.amplience.net/i/fitflop/404?fmt=auto&qlt=default';
  const mainImage =
    (product.imageSet && product.imageSet.items && product.imageSet.items[0] && product.imageSet.items[0].src) ||
    product404ImageSrc;

  return (
    <div className="pdp-modal__content add-product-confirmation__view">
      <div className="add-product-image-container">
        <Image alt={product.name} className="add-product-image" media={{ url: mainImage }} sizes={{ s: '150px' }} />
      </div>
      <div className="add-product-confirmation__added">
        <FormattedMessage id={addedMsgId} description="Added" />
        <span className="add-product-confirmation__icon icon-tick-filled" />
      </div>
      {FREE_DELIVERY_VISIBLE && cartData && (
        <div className="add-product-confirmation__threshold">
          <p>
            {cartData.subTotalWithoutDiscountsValue < THRESHOLD
              ? getBelowThresholdMsg(cartData.subTotalWithoutDiscountsValue)
              : ABOVE_THRESHOLD_MSG.replace('&#39;', "'")}
          </p>
        </div>
      )}
      <div className="add-product-confirmation__user-actions">
        <div className="add-product-confirmation__view-added-products">
          <a className="product-info__button product-info__button--no-link" href={addedProductsUrl}>
            <FormattedMessage id={viewAddedProductsMsgId} description="View" />
          </a>
        </div>
        <div className="add-product-confirmation__continue">
          <button type="button" className="product-info__link product-info__link--no-button" onClick={closeProductInfo}>
            <FormattedMessage id="order.confirmation.continue.shopping" description="Continue shopping" />
          </button>
        </div>
      </div>
    </div>
  );
}

ConfirmationView.propTypes = {
  product: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }).isRequired,
  closeProductInfo: PropTypes.func.isRequired,
  addedMsgId: PropTypes.string.isRequired,
  viewAddedProductsMsgId: PropTypes.string.isRequired,
  addedProductsUrl: PropTypes.string.isRequired,
};

export default ConfirmationView;
